

export class ValueCollector {
  public values: number[] = [];
  public count = 0;

  public arithmetic = 0;
  public geometric = 0;
  public harmonic = 0;
  public minimum = 0;
  public maximum = 0;
  public deviation = 0;
  public changed = false;

  constructor(private maxCount: number, private frequency?: number) {}

  private calculateArithmeticMean(array: number[]): number {
    return (
      array.reduce(function (a, b) {
        return a + b;
      }, 0) / array.length
    );
  }

  private calculateGeometricMean(array: number[]): number {
    return Math.pow(
      array.reduce(function (a, b) {
        if (!a) return b;
        return b ? a * b : a;
      }, 0),
      1 / array.length
    );
  }

  private calculateHarmonicMean(array: number[]): number {
    const invSum = array.reduce(function (a, b, i) {
      if (!b) return a;
      else if (!(i - 1)) return (a ? 1 / a : 0) + 1 / b;
      else return a + 1 / b;
    }, 0);

    return invSum ? array.length / invSum : 0;
  }

  private calculateStandardDeviation(array: number[], arithmetic?: number): number {
    const m = arithmetic || this.calculateArithmeticMean(array);
    return array.length > 1 ? Math.sqrt(array.reduce(function (sq, n) {
      return sq + Math.pow(n - m, 2);
    }, 0) / (array.length - 1)) : 0;
  }

  private getRounded(value: number, toFixed = 0): number {
    if (toFixed === -1) {
      return value; // No rounding required
    }
    const rounded: number = parseFloat(value.toFixed(toFixed));
    return rounded;
  }

  public add(value: number, toFixed = 0, outlierNormalize = 0): Record<string, number> {
    this.values.push(value);
    while (this.values.length > this.maxCount) {
      this.values.shift();
    }
    this.count++;
    this.changed = false;
    if (!this.frequency || (this.frequency && this.count % this.frequency === 0)) {
      this.update(toFixed, outlierNormalize);
    }

    return this.get(toFixed);
  }

  private update(toFixed = 0, outlierNormalize = 0): void {
    const sorted: Array<number> = JSON.parse(JSON.stringify(this.values)).sort(function (a: number, b: number) {
      return a - b;
    });
    for (let i = 0; i < outlierNormalize; i += 1) {
      if (sorted.length > 2) {
        sorted.shift();
        sorted.pop();
      }
      if (i === outlierNormalize - 1) {
        const min = sorted[0];
        const max = sorted[sorted.length-1];
        for (let i = 0; i < outlierNormalize; i += 1) {
          sorted.unshift(min);
          sorted.push(max);
        }
      }
    }

    this.arithmetic = this.getRounded(this.calculateArithmeticMean(sorted), toFixed);
    //this.geometric = this.getRounded(this.calculateGeometricMean(sorted), toFixed);
    //this.harmonic = this.getRounded(this.calculateHarmonicMean(sorted), toFixed);
    this.minimum = sorted[0];
    this.maximum = sorted[sorted.length - 1];
    this.deviation = this.getRounded(this.calculateStandardDeviation(sorted, this.arithmetic), toFixed);
    this.changed = true;
  }

  public get(toFixed: number): Record<string, number> {
    return {
      'minimum': this.getRounded(this.minimum, toFixed),
      'maximum': this.getRounded(this.maximum, toFixed),
      'arithmetic': this.getRounded(this.arithmetic, toFixed),
      //'geometric': this.getRounded(this.geometric, toFixed),
      //'harmonic': this.getRounded(this.harmonic, toFixed),
      'deviation': this.getRounded(this.deviation, toFixed),
      'count': this.getRounded(this.count, toFixed)
    };
  }
}
